export enum ShapeType {
  Circle = 'circle',
  Arrow = 'arrow',
  Text = 'text',
}

export interface Coordinate {
  x: number;
  y: number;
}

export interface ShapeInfo {
  id: string;
  type: ShapeType;
  startCoordinate: Coordinate | null;
  endCoordinate: Coordinate | null;
  strokeColor?: string;
  text?: string;
}
